import { ModuleWithProviders, NgModule } from '@angular/core';
import { FeatureTogglesConfigLoaderService, FeatureTogglesModule } from '@ceres/feature-toggles';
import { CeresFeaturesConfig } from '@ceres/shared/features';
import { AppConfigFeaturesAdapterService } from './services/app-config-features-adapter.service';

@NgModule({
    imports: [FeatureTogglesModule.forRoot<CeresFeaturesConfig>()],
    exports: [FeatureTogglesModule]
})
export class FeaturesModule {
    public static forRoot(): ModuleWithProviders<FeaturesModule> {
        return {
            ngModule: FeaturesModule,
            providers: [
                {
                    provide: FeatureTogglesConfigLoaderService,
                    useClass: AppConfigFeaturesAdapterService
                }
            ]
        };
    }

    public static forChild(): ModuleWithProviders<FeaturesModule> {
        return {
            ngModule: FeaturesModule
        };
    }
}
